<template>
  <BaseModule
    class="user-setting"
    @click="click"
    :data="{
      name: '提问设置',
      icon: 'icon-pr_phone_icon_setting_small',
      icon_body: null
    }"
    :isEditMode="isEditMode"
    :lang="{ click: lang.click }"
  >
    <div class="user-setting-block" :class="isMobile ? '':'blue'">
      <div class="user-setting-block-left">
        {{lang.enable_qa}}
      </div>
      <div class="user-setting-block-right">
        <BaseInput v-model.number="input.qa_price" :unit="lang.enable_qa_unit" type="number" width="80px"></BaseInput>
      </div>
    </div>
    <div class="user-setting-block">
      <div class="user-setting-block-left">
        {{lang.enable_sendbp}}
      </div>
      <div class="user-setting-block-right">
        <BaseSwitch :value="input.enable_sendbp" @click="updateEnableSendbp"></BaseSwitch>
      </div>
    </div>
  </BaseModule>
</template>

<script>
import _ from 'lodash'
import env from '@/env.js'
import { ranch } from '@/api'
import Store from '@/Store.js'

import BaseModule from './BaseModule.vue'

import {
  BaseInput,
  BaseSwitch
} from '@/components'

export default {
  components: {
    BaseModule,
    BaseInput,
    BaseSwitch
  },
  props: {
    lang: {
      type: Object,
      default () {
        return {
          enable_qa: '向我提问需要支付',
          enable_qa_unit: '元',
          enable_sendbp: '是否接受BP投递',
          click: '保存'
        }
      }
    },
    data: {
      type: Object,
      required: true
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMobile () {
      return env.isMobile
    }
  },
  data () {
    return {
      inputTemp: {
        qa_price: _.get(this.data, 'investor.deliverPrice', 0) / 100,
        enable_sendbp: !_.get(this.data, 'investor.state') // 0 正常 1 不可投遞
      },
      input: {
        qa_price: _.get(this.data, 'investor.deliverPrice', 0) / 100,
        enable_sendbp: !_.get(this.data, 'investor.state')
      },
      isLocked: false,
      error: null
    }
  },
  methods: {
    async click () {
      if (this.isLocked) {
        return
      }
      try {
        this.isLocked = true
        let inputFixed = {
          deliverPrice: this.input.qa_price * 100,
          // 0 正常 1 不可投遞
          state: this.input.enable_sendbp ? 0 : 1
        }
        let res = await ranch.post('/investor/usave', inputFixed, {
          headers: {
            'tephra-session-id': Store.get('sid')
          }
        })
        if (_.get(res, 'data.code') !== 0) {
          throw new Error(_.get(res, 'data.msg'))
        }
        this.inputTemp = _.cloneDeep(this.input)
        this.$emit('update:data', {
          investor: inputFixed
        })
      } catch (e) {
        this.error = _.get(e, 'response.data.msg') || e.message
        this.input = _.cloneDeep(this.inputTemp)
      } finally {
        this.isLocked = false
      }
    },
    updateEnableSendbp (enable) {
      this.input.enable_sendbp = enable
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.user-setting {
  & .user-setting-block {
    position: relative;
    height: 64px;
    &.blue {
      background-color: rgba(247,249,255,1);
    }
    & .user-setting-block-left {
      margin-left: 53px;
      display: inline-block;
      font-weight: bold;
    }
    & .user-setting-block-right {
      position: absolute;
      display: inline-block;
      right: 0;

      padding: 8px 0;
      @media (--mediaPc) {
        margin: 0 45px;
      }
      @media (--mediaMobile) {
        margin: 0 calc(32px / var(--scaleMobile));
      }
    }
    &::before {
      content: '';
      width: 0;
      height: 100%;
      display: inline-block;
      position: relative;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/module/UserSettingModule.vue